var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17461 0.869141H0.401611V17.1321H12.7896V4.48214L9.17461 0.869141ZM11.1616 4.20414H9.45361V2.49514L11.1616 4.20414ZM2.03261 16.1791L4.45061 13.7691L5.88061 15.1991L9.45361 11.6261V12.8711H10.4066V10.0171H7.54861V10.9691H8.76761L5.88161 13.8551L4.45361 12.4271L1.35361 15.5091V1.82214H8.50161V5.15714H11.8366V16.1791H2.03261Z",
    fill: "#494950"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78357 4.20508H6.58357V5.15808H2.78357V4.20508Z",
    fill: "#494950"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78357 6.57812H6.58357V7.53113H2.78357V6.57812Z",
    fill: "#494950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.f60a87f9.svg";
export { ForwardRef as ReactComponent };